import axios from "axios";

export default {
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/recipe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/recipe/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll(currentPage = 0, pageSize = 10, filter) {
        return axios({
            method: "get",
            params: filter,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/recipes?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getPdf(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/recipe/report/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    send(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/recipe/send/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    validateByToken(token) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "public/recipe/" +
                token +
                "/validate",
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
    getByToken(token) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/recipe/" + token,
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
    getPdfByToken(token) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/recipe/report/" + token,
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
};
